import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const OktaDebugInfo = () => {
  const { oktaAuth } = useOktaAuth();
  const [debugInfo, setDebugInfo] = useState({});

  useEffect(() => {
    if (oktaAuth) {
      setDebugInfo({
        issuer: oktaAuth.options.issuer,
        clientId: oktaAuth.options.clientId,
        redirectUri: oktaAuth.options.redirectUri,
        scopes: oktaAuth.options.scopes,
        hostname: window.location.hostname,
        origin: window.location.origin,
        href: window.location.href,
        nodeEnv: process.env.NODE_ENV,
        oktaIssuer: process.env.REACT_APP_OKTA_ISSUER,
        oktaClientId: process.env.REACT_APP_OKTA_CLIENT_ID
      });
    }
  }, [oktaAuth]);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      right: 0, 
      background: 'rgba(0,0,0,0.8)', 
      color: 'white', 
      padding: '10px',
      fontSize: '12px',
      maxWidth: '400px',
      zIndex: 9999
    }}>
      <h4>Okta Debug Info</h4>
      <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
      <div style={{ marginTop: '10px', padding: '5px', background: 'rgba(255,255,255,0.1)' }}>
        <strong>Required Okta App Configuration:</strong><br/>
        Redirect URIs must include:<br/>
        • {window.location.origin}/login/callback<br/>
        • https://onboarding-form-app.juniper.net/login/callback
      </div>
    </div>
  );
};

export default OktaDebugInfo;
